import { useEffect } from 'react'
import { Button, Form, message, Input, InputNumber } from 'antd'
import {Top} from '../../components/Top'
import { useMutation, useQuery } from '@apollo/client'
import { useUser } from '../../utils/hooks'

import { useNavigate, useParams } from 'react-router-dom'
import { DELETE_ONE_REVIEW, FIND_MANY_REVIEW, UPDATE_ONE_REVIEW } from '../../gqls'
import { DELETE_ONE_OBJECT_TYPE, FIND_MANY_OBJECT_TYPE, UPDATE_ONE_OBJECT_TYPE } from '../../gqls/objecttype'

const { TextArea } = Input

const UpdateObjectType = () => {
  // const { id } = match.params
  const { user, loading: loadingMe } = useUser()

  const { id } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (!user?.role?.canObject) navigate(-1)
  })

  const { data, loading: loadingAdmin } = useQuery(FIND_MANY_OBJECT_TYPE, {
    fetchPolicy: 'network-only',
    variables: { where: { id: { equals: id } } },
  })

  const onCompleted = () => navigate(-1)

  const onError = (err) => {
    console.error(err)
    message.error('Не удалось выполнить запрос')
  }

  const [updateOne, { loading }] = useMutation(UPDATE_ONE_OBJECT_TYPE, {
    onCompleted,
    onError,
  })

  const [deleteOne, { loading: loadingDel }] = useMutation(DELETE_ONE_OBJECT_TYPE, {
    onCompleted,
    onError,
  })

  const handleCreate = (v) => {
    updateOne({
      variables: {
        where: { id },
        data: { 
          title: {set:v.title }
         },
      },
    })
  }

  const deleteAdmin = () => {
    let isRight = window.confirm('Вы уверены, что хотите удалить данные?')
    if (isRight) deleteOne({ variables: { where: { id } } })
  }

  if (loadingMe || loadingAdmin) return 'Загрузка...'
  if (!user?.role?.canObject) return 'Ошибка'
  const admin = data?.findManyObjectType[0]

  return (
    <>
      <Top title='Изменить данные' />
      <div style={{ maxWidth: 500 }}>
        <Form initialValues={{ ...admin }} onFinish={handleCreate} layout='vertical'>
          <Form.Item name='title' label='Заголовок' required>
            <Input />
          </Form.Item>

          <Button loading={loading || loadingDel} htmlType='submit' type='primary'>
            Изменить
          </Button>
        </Form>
        <div style={{ paddingTop: 30 }}>
          <hr />
          <Button danger ghost loading={loading || loadingDel} onClick={deleteAdmin} type='primary'>
            Удалить
          </Button>
        </div>
      </div>
    </>
  )
}

export default UpdateObjectType
